import { render } from "./monitor.vue?vue&type=template&id=e2b896b6&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"

import "./monitor.vue?vue&type=style&index=0&id=e2b896b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b896b6"]])

export default __exports__